/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Awaiting_Activation_TitleInputs */



/**
* | output |
* | --- |
* | "Waiting to be activated" |
*
* @param {Org_Awaiting_Activation_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const org_awaiting_activation_title = /** @type {((inputs?: Org_Awaiting_Activation_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Awaiting_Activation_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Warten auf Aktivierung")
	return /** @type {LocalizedString} */ ("Waiting to be activated")
});